// Cardiovascular Diseases
const cardiovascularDiseasesAr = [
    "Coronary Heart Disease (CHD)",
    "Stroke",
    "Hypertension (High Blood Pressure)",
    "Heart Failure",
    "Arrhythmias",
    "Atherosclerosis",
    "Peripheral Artery Disease (PAD)",
    "Rheumatic Heart Disease",
    "Cardiomyopathy",
    "Angina",
    "Deep Vein Thrombosis (DVT)",
    "Pulmonary Embolism",
    "Myocardial Infarction (Heart Attack)",
    "Endocarditis",
    "Aortic Aneurysm",
    "Mitral Valve Prolapse",
    "Hypertrophic Cardiomyopathy",
    "Ventricular Tachycardia",
    "Atrial Fibrillation",
    "Congenital Heart Defects",
];

const cardiovascularDiseases = cardiovascularDiseasesAr.reduce((accumulator, disease) => {
    accumulator.push({category: 'Cardiovascular', disease})
    return accumulator
}, [])

export default cardiovascularDiseases